<template lang="html">
  <v-dialog
    v-model="WarningDialog"
    persistent
    :overlay="false"
    max-width="500px"
    transition="dialog-transition"
  >
    <!-- <v-card :style="stylechat">
      <v-card-title primary-title style="justify-content: center;">
        {{WarningDialogDetail.title}}
      </v-card-title>
      <v-card-text style="text-align: center;">
        <span class="fontsize-span">{{WarningDialogDetail.text}}</span>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-row justify="center" align="center">
          <v-col cols="6" align="center">
            <v-btn class="btn-color-confirm" block text @click="confirmData()">{{$t('AnswerQuestion.ok')}}</v-btn>
          </v-col>
          <v-divider vertical class="mt-1"></v-divider>
          <v-col cols="6" align="center">
            <v-btn class="btn-color-cancel" block text @click="closeDialog()">{{$t('AnswerQuestion.cancel')}}</v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card> -->
    <v-card :style="stylechat">
      <v-card-title
        class="main-fontsize"
        primary-title
        style="justify-content: center"
      >
        {{ WarningDialogDetail.title }}
      </v-card-title>
      <v-card-text style="text-align: center">
        <span class="fontsize-span sub-fontsize">{{
          WarningDialogDetail.text
        }}</span>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <!-- btn paste image -->
        <v-row
          v-if="type === 'paste-image' || type === 'paste-image-contextmenu'"
          justify="center"
          align="center"
        >
          <v-col cols="6" align="center">
            <v-btn
              class="btn-color-text"
              block
              text
              @click="confirmDataPaste('text')"
              >{{ $t("AnswerQuestion.text") }}</v-btn
            >
          </v-col>
          <v-divider vertical class="mt-1"></v-divider>
          <v-col cols="6" align="center">
            <v-btn
              class="btn-color-image"
              block
              text
              @click="confirmDataPaste('image')"
              >{{ $t("AnswerQuestion.image") }}</v-btn
            >
          </v-col>
        </v-row>
        <!-- btn warning -->
        <v-row v-else justify="center" align="center">
          <v-col cols="6" align="center">
            <v-btn
              class="btn-color-confirm main-fontsize"
              block
              text
              @click="confirmData()"
              >{{ $t("AnswerQuestion.ok") }}</v-btn
            >
          </v-col>
          <v-divider vertical class="mt-1"></v-divider>
          <v-col cols="6" align="center">
            <v-btn
              class="btn-color-cancel main-fontsize"
              block
              text
              @click="closeDialog()"
              >{{ $t("AnswerQuestion.cancel") }}</v-btn
            >
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    WarningDialog: Boolean,
    WarningDialogDetail: {}
  },
  data () {
    return {
      tokenbot: '',
      password: '',
      stylechat: {
        "--WarningDialog-HeaderColor": "white",
        "--WarningDialog-TabBackground": "white",
        "--WarningDialog-Icon": "gray",
        "--WarningDialog-IconActive": "#2662ae",
        "--WarningDialog-Background": "white",
        "--WarningDialog-FontSize": "18px",
        "--WarningDialog-FontColor": "black",
        "--WarningDialog-FontSize-Status": "16px",
        "--WarningDialog-FontSize-Text": "17px",
        "--WarningDialog-Color-Text": "#727272",
        "--WarningDialog-FontColor-Status": "grey",
        "--WarningDialog-Background-Input": "#E2E1E3",
        "--WarningDialog-Color-Button": "#EFF2FE",
        "--WarningDialog-FontColor-Button": "#2662ae",
        "--WarningDialog-FontColor-Button-Cancel": "#cb1002",
        "--WarningDialog-FontColor-Button-Text": "#353535",
      },
      type: "",
    }
  },
  watch: {
    WarningDialog () {
      // console.log(this.WarningDialog)
      // console.log(this.WarningDialogDetail)
      if (this.WarningDialog) {
        // this.tokenbot = this.WarningDialogDetail.user.tokenuser
        this.type = this.WarningDialogDetail.detail.methods;
      }
    }
  },
  methods: {
    closeDialog () {
      this.$emit('closeAlertDialog', { type: 'warning', value: false })
    },
    confirmData () {
      this.$emit('emitWarning', this.WarningDialogDetail)
    },
    confirmDataPaste(type) {
      if (type === "text") {
        this.WarningDialogDetail.type = "text";
        this.$emit("emitWarning", this.WarningDialogDetail);
      } else {
        this.WarningDialogDetail.type = "image";
        this.$emit("emitWarning", this.WarningDialogDetail);
      }
    },
  }
}
</script>

<style lang="css" scoped>
.fontsize-span {
  font-size: var(--WarningDialog-FontSize-Text) !important;
  color: var(--WarningDialog-Color-Text) !important;
}
.btn-color-confirm {
  color: var(--WarningDialog-FontColor-Button) !important;
  text-transform: none !important;
  font-weight: 600;
  font-size: var(--WarningDialog-FontSize) !important;
}
.btn-color-cancel {
  color: var(--WarningDialog-FontColor-Button-Cancel) !important;
  text-transform: none !important;
  font-size: var(--WarningDialog-FontSize) !important;
}
.btn-color-text {
  color: var(--WarningDialog-FontColor-Button-Text) !important;
  text-transform: none !important;
  font-size: var(--WarningDialog-FontSize) !important;
}
.btn-color-image {
  color: var(--WarningDialog-FontColor-Button) !important;
  text-transform: none !important;
  font-weight: 600;
  font-size: var(--WarningDialog-FontSize) !important;
}
>>>.v-dialog {
  border-radius: 15px;
  margin: 24px;
  overflow: hidden;
  pointer-events: auto;
  width: 100%;
  z-index: inherit;
  outline: none;
}
>>>.v-input__slot {
  background-color: var(--WarningDialog-Background-Input) !important;
  border-radius: 10px !important;
}
>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
  box-shadow: none !important;
}
</style>
